import TableHead from '@material-ui/core/TableHead';

export default TableHead;
